// removed by extract-text-webpack-plugin
module.exports = {"primaryColor":"#509119","secondaryColor":"#0E62AA","backButtonColor":"#DCDCDC"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1cee92aa","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Dashboard/Views/Utils/DatePicker.vue
// module id = vgYp
// module chunks = 0